import { render, staticRenderFns } from "./UserQuotes.vue?vue&type=template&id=60281acc&scoped=true"
import script from "./UserQuotes.vue?vue&type=script&lang=js"
export * from "./UserQuotes.vue?vue&type=script&lang=js"
import style0 from "./UserQuotes.vue?vue&type=style&index=0&id=60281acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60281acc",
  null
  
)

export default component.exports